// import { letterStatuses } from "../StaticData/UniversityLetter";

export default function UniversityLetters({ letters }) {

  return (
    <div className="bg-white p-6 rounded-lg shadow-custom">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        University Letters
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div
          className="bg-[#87CA60] rounded-xl p-4 flex flex-col space-y-1"
        >
          <span className="text-gray-900 font-medium text-sm sm:text-base">
            Applied
          </span>
          <span className="text-xl sm:text-2xl font-semibold text-gray-900">
            {letters?.universityLetterAppliedCount || 0}
          </span>
        </div>
        <div
          className="bg-[#87CA60] rounded-xl p-4 flex flex-col space-y-1"
        >
          <span className="text-gray-900 font-medium text-sm sm:text-base">
            Processed
          </span>
          <span className="text-xl sm:text-2xl font-semibold text-gray-900">
            {letters?.universityLetterProcessedCount || 0}
          </span>
        </div>
        <div
          className="bg-[#87CA60] rounded-xl p-4 flex flex-col space-y-1"
        >
          <span className="text-gray-900 font-medium text-sm sm:text-base">
            Rejected
          </span>
          <span className="text-xl sm:text-2xl font-semibold text-gray-900">
            {letters?.universityLetterRejectedCount || 0}
          </span>
        </div>
      </div>
    </div>
  )
}